import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import axios from "axios";
import url from "../../../url.js";
import * as actions from "../../../store/actions/benefits.js";
import "./benefit.css";

class Benefits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      add: false,
      change: {
        name: "",
        description: "",
        _id: ""
      }
    };
    this.onClick = this.onClick.bind(this);
    this.add = this.add.bind(this);
    this.newBenefit = this.newBenefit.bind(this);
    this.resizedataURL = this.resizedataURL.bind(this);
    this.encodeImageFileAsURL = this.encodeImageFileAsURL.bind(this);
    this.requiresReservation = this.requiresReservation.bind(this);
    this.click = this.click.bind(this);
  }
  componentDidMount() {
    this.props.onMount();
  }

  onClick(id, e) {
    e.preventDefault();
    console.log(id);
    this.props.onBenefitClick(id);
  }

  click() {
    const current = this.state.change;
    current.requiresReservation = !current.requiresReservation;
    this.setState({ change: current });
  }

  smaller(picture, wantedWidth, wantedHeight, img) {
    // We create a canvas and get its context.
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");

    // We set the dimensions at the wanted size.
    canvas.width = wantedWidth;
    canvas.height = wantedHeight;
    console.log(picture);
    // We resize the image with the canvas method drawImage();
    ctx.drawImage(picture, 0, 0, wantedWidth, wantedHeight);

    var dataURI = canvas.toDataURL("image/jpeg", 0.8);
    console.log(dataURI);
    /////////////////////////////////////////
    // Use and treat your Data URI here !! //
    /////////////////////////////////////////
    /*
      this.parent.setState({
          imagePreviewUrl: dataURI,
          image: dataURI,
      });
      */
    if (this.state.add) {
      const current = this.state.change;
      current["picture"] = dataURI;
      this.setState({ change: current });
    }
  }

  resizedataURL(datas, wantedWidth, wantedHeight) {
    // We create an image to receive the Data URI
    var img = document.createElement("img");

    img.parent = this;
    // When the event "onload" is triggered we can resize the image.
    img.onload = this.smaller.bind(this, img, wantedWidth, wantedHeight);

    // We put the Data URI in the image's src attribute
    img.src = datas;
  }

  encodeImageFileAsURL(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      this.resizedataURL(reader.result, 350, 350);
    };
    reader.readAsDataURL(file);
  }

  renderBenefits() {
    return this.props.benefits.map(benefit => {
      const requiresReservation = benefit.requiresReservation;
      var a = "";
      if (requiresReservation) {
        a += "Krever reservasjon";
      } else {
        a += "Krever ikke reservasjon";
      }
      return (
        <div className="card" onClick={this.onClick.bind(null, benefit._id)}>
          <h1 className="prodName">{benefit.name}</h1>

          <p className="title">{benefit.description}</p>
        </div>
      );
    });
  }

  changeValue(key, e) {
    e.preventDefault();
    if (this.state.add) {
      const current = this.state.change;
      current[key] = e.target.value;
      this.setState({ change: current });
    }
  }

  add() {
    this.setState({
      add: !this.state.add
    });
  }
  newBenefit(e) {
    e.preventDefault();
    console.log(this.state.change.price);
    console.log(this.state.change.name);
    console.log(this.state.change.description);
    console.log(this.state.change.taxRate);
    console.log(this.state.change.requiresReservation);
    console.log(this.state.change.picture);
    if (
      this.state.change.name.length > 0 &&
      this.state.change.description.length > 0
    ) {
      const info = {
        name: this.state.change.name,
        description: this.state.change.description
      };
      this.setState({ fetching: true });
      const token = window.localStorage.getItem("token");
      const changes = this.state.change;
      delete changes._id;
      axios
        .post(url + "admin/benefits/", info, {
          headers: { Authorization: token }
        })
        .then(response => {
          this.setState({
            change: {
              name: "",
              description: ""
            },
            add: false
          });
          this.props.onMount();
        })
        .catch(error => {
          this.setState({ error: true, fetching: false });
        });
    }
  }

  requiresReservation(e) {
    if ((e.checked = "checked")) {
      return true;
    } else {
      return false;
    }
  }

  disabled(bool) {
    if (bool) {
      return {
        background: "#757575"
      };
    } else {
      {
      }
    }
  }

  checkChange() {
    if (
      this.state.change.name.length < 1 ||
      this.state.change.description.length < 1
    ) {
      return true;
    } else {
      return false;
    }
  }

  newForm() {
    if (this.state.add) {
      return (
        <div style={styles.del}>
          <div style={styles.delCard}>
            <h2>Ny fordel</h2>
            <div>
              <form onSubmit={this.newBenefit}>
                <input
                  placeholder="Fordelsnavn"
                  onChange={this.changeValue.bind(this, "name")}
                  type="text"
                  className="add-inputF"
                  value={this.state.change.name}
                  maxlength="60"
                  required
                />
                <textarea
                  placeholder="Fordelsbeskrivelse"
                  onChange={this.changeValue.bind(this, "description")}
                  type="text"
                  className="add-inputText"
                  maxlength="250"
                  value={this.state.change.description}
                  required
                />
              </form>

              <div style={styles.delCont}>
                <button
                  onClick={e => {
                    e.preventDefault();
                    this.setState({ add: false });
                  }}
                  style={styles.button}
                  className="change"
                >
                  Avbryt
                </button>
                <button
                  disabled={this.checkChange()}
                  onClick={this.newBenefit}
                  style={{
                    ...styles.button,
                    ...this.disabled(this.checkChange())
                  }}
                  className="save"
                >
                  Legg til
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return "";
  }

  render() {
    console.log("Access object:");
    console.log(this.props);

    return (
      <div>
        <h1>Fordeler</h1>
        {this.props.access && this.props.access.benefits.write ? 
        (<button
          onClick={this.add}
          style={{ ...styles.button, ...{ marginLeft: "0px" } }}
          className="save"
        >
          {" "}
          Legg til ny{" "}
        </button>) : ("")}
        {this.newForm()}
        <div className="band">{this.renderBenefits()}</div>
      </div>
    );
  }
}

const styles = {
  button: {
    width: "120px",
    marginBottom: "20px",
    marginTop: "20px",
    marginRight: "10px",
    marginLeft: "10px",
    paddingTop: "5px",
    paddingBottom: "5px",
    paddingLeft: "5px",
    paddingRight: "5px",
    fontSize: "18px",
    borderRadius: "8px"
  },
  del: {
    position: "fixed",
    height: "100vh",
    width: "100vw",
    backgroundColor: "#00000070",
    top: 0,
    left: 0,
    zIndex: 2000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  delCard: {
    flex: "",
    height: "300px",
    width: "95%",
    maxWidth: "400px",
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "5px 5px 5px 5px",
    textAlign: "center"
  },
  delCont: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "90%"
  }
};

const mapStateToProps = state => {
  return {
    benefits: state.benefits.data,
    access: state.login.user.info.permissions,
    error: state.benefits.error.active,
    loading: state.benefits.isFetching,
    message: state.benefits.error.message
  };
  console.log("Map state to props");
  console.log(this.props.access);
};

const mapDispatchToProps = dispatch => {
  return {
    onMount: () => {
      dispatch(actions.getBenefits());
    },

    onBenefitClick: id => {
      console.log("IDEN" + id);
      dispatch(push(`/admin/benefits/${id}`));
    }
  };
};

const BenefitsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Benefits);

export default BenefitsContainer;
